import { IntlShape } from 'react-intl';

export const dictionary = {
    channels_tv_program_movie: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.channel.aed34b9f60ee115dfa7918b742336277',
            defaultMessage: 'movie',
            description: 'Название фильма в типах контента',
        }),
    channels_tv_program_series: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.channel.8158f53b1911383cf67518088bb0d051',
            defaultMessage: 'TV series',
            description: 'Название сериала в типах контента',
        }),
    channels_tv_program_show: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.channel.a7dd12b1dab17d25467b0b0a4c8d4a92',
            defaultMessage: 'show',
            description: 'Название шоу в типах контента',
        }),
    channels_tv_program_sport: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.channel.088495f30901580ddd5171531cd26649',
            defaultMessage: 'sports',
            description: 'Название спорта в типах контента',
        }),
    channels_modal_play_button: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'containers.ChannelCardModal.button-text-modal.5f87a87c3d6e140cc783a0088e99fb7f',
            defaultMessage: 'Play channel',
            description: 'Текст кнопки просмотра канала в модальном окне',
        }),
    channels_dropdown_button_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.ChannelsPage.e1cacb68b8c2938eedf5d72d6891dab3',
            defaultMessage: 'More channels',
            description: 'Лейбл кнопки "Другие каналы"',
        }),
    channels_paywall_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.channels.ui.channels-paywall.12ee666acf873a1d2d004c99b1951ae4',
            defaultMessage: 'Watch sports events, follow news, enjoy TV shows, and much more',
            description: 'Заголовок пейволла телеканалов',
        }),
    channels_arrow_button_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.channels.ui.channels-paywall.60cce296eac2825ba3e2040b328c910c',
            defaultMessage: 'Explore the channels list',
            description: 'Текст для стрелки, ведущей на список каналов',
        }),
    channels_offer_button_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.channel.5f87a87c3d6e140cc783a0088e99fb7f',
            defaultMessage: 'Play channel',
            description: 'Текст кнопки для просмотра канала',
        }),
    channels_all_channels_category: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.channel.ed722f26019999ed029c3a032a4fd536',
            defaultMessage: 'All channels',
            description: 'Заголовок вкладки "Все каналы"',
        }),
    channels_card_modal_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.channel.95503adcf22de454242e62fcb6461775',
            defaultMessage: 'This channel is available with a subscription',
            description: 'Заголовок оффера для подписки на каналы',
        }),
    channels_page_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.ChannelsPage.546ba086eaa37e30303fd8e364b57bd7',
            defaultMessage: 'TV Channels',
            description: 'Заголовок страницы каналов',
        }),
    channels_login_button: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.ChannelsPage.be11c74c1dd7f307bb80183a90dc2067',
            defaultMessage: 'Get started',
            description: 'Текст кнопки оффера при включенном логинволе',
        }),
    channels_watch_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.content-actions.de3c731be5633838089a07179d301d7b',
            defaultMessage: 'Play',
            description: 'Текст кнопки "Смотреть"',
        }),
    channels_on_the_air_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.channels.i18n.930e348dbe18ea803462a1dfd73e18e1',
            defaultMessage: 'Streaming now',
            description: 'Состояние "в эфире"',
        }),
    subscription_offer_button_get_started: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.ChannelsPage.be11c74c1dd7f307bb80183a90dc2067',
            defaultMessage: 'Get started',
            description: 'Текст кнопки оффера при включенном логинволе',
        }),
    subscription_offer_button_subscribe: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.offer-button.dfa592421ec2584a960f077610eb19bd',
            defaultMessage: 'Subscribe now',
            description: 'Текст кнопки оформления подписки',
        }),
};
